// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e3c83439","453":"8d0608ac","732":"4426cf48"}[chunkId] + ".chunk.js";
};